import PrintSheet from "@/modules/print/sheet";
import { QrImage } from "@/modules/qr/qr-image";

interface Props {
  companyName: string;
  companyTel: string;
  url: string;
  qrSvg: string;
}

// 간편접수 안내문 A4 한 장 — 매장·현장에 붙인다. 최소 높이는 공사 안내문과 같게 잡아 한 장을 넘지 않는다.
const IntakePoster = ({ companyName, companyTel, url, qrSvg }: Props) => (
  <PrintSheet className="flex flex-col items-center gap-8 text-center a4:min-h-[297mm] a4:p-12 print:min-h-[265mm]!">
    <h1 className="mt-6 break-keep text-4xl font-bold" data-testid="intake-poster-company">
      {companyName}
    </h1>
    <p className="break-keep text-2xl font-semibold leading-relaxed" data-testid="intake-poster-guide">
      QR 을 찍으면 인테리어 견적 문의를
      <br />
      바로 남길 수 있어요
    </p>
    <QrImage alt="간편접수 QR" className="size-[110mm] max-w-full" svg={qrSvg} />
    <p className="text-base text-[#525252]">휴대폰 카메라로 비추면 문의 화면이 열립니다. 담당자가 확인 후 연락드립니다.</p>
    <div className="mt-auto flex flex-col items-center gap-1 border-t border-[#d9d9d9] pt-4" data-testid="intake-poster-footer">
      <p className="break-all text-sm" data-testid="intake-poster-url">
        {url}
      </p>
      {companyTel && <p className="text-sm">문의 {companyTel}</p>}
    </div>
  </PrintSheet>
);

export default IntakePoster;
